import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form-field__value" }

import { FieldWrapper as KFieldWrapper } from '@progress/kendo-vue-form';
import { Error as KError, Hint as KHint } from '@progress/kendo-vue-labels';
import TextBox from '@/components/common/textBox/TextBox.vue';
import FormLabel from '@/components/common/label/FormLabel.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormInput',
  props: /*@__PURE__*/_mergeModels({
    disabled: { type: Boolean, default: false },
    placeholder: { default: undefined },
    isValid: { type: Boolean, default: true },
    isRequired: { type: Boolean, default: false },
    label: { default: "" },
    link: { default: undefined },
    validationMessage: { default: undefined },
    hintMessage: { default: undefined },
    width: { default: '230px' },
    size: { default: 'large' },
    fillMode: { default: 'outline' }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const model = _useModel<string | number | undefined>(__props, "modelValue");



function handleChange() { }

const componentId = Math.random()?.toString();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KFieldWrapper), { class: "form-field" }, {
    default: _withCtx(() => [
      _createVNode(FormLabel, {
        "label-text": __props.label,
        "is-required": __props.isRequired,
        "is-disabled": __props.disabled,
        "is-valid": __props.isValid,
        "input-id": _unref(componentId),
        size: 'medium'
      }, {
        "label-after": _withCtx(() => [
          _renderSlot(_ctx.$slots, "label-after")
        ]),
        _: 3
      }, 8, ["label-text", "is-required", "is-disabled", "is-valid", "input-id"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TextBox, _mergeProps({ id: _unref(componentId) }, _ctx.$attrs, {
          modelValue: model.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
          width: __props.width,
          valid: __props.isValid,
          disabled: __props.disabled,
          placeholder: __props.placeholder,
          size: __props.size,
          "fill-mode": __props.fillMode,
          autocomplete: "off",
          onInput: handleChange
        }), null, 16, ["id", "modelValue", "width", "valid", "disabled", "placeholder", "size", "fill-mode"]),
        (__props.validationMessage)
          ? (_openBlock(), _createBlock(_unref(KError), {
              key: 0,
              class: "form-field__errors"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.validationMessage), 1)
              ]),
              _: 1
            }))
          : (__props.hintMessage)
            ? (_openBlock(), _createBlock(_unref(KHint), { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.hintMessage), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

})